"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _SvgIcon = _interopRequireDefault(require("material-ui/SvgIcon"));
var _addCircle = _interopRequireDefault(require("material-ui/svg-icons/content/add-circle"));
var _image = _interopRequireDefault(require("material-ui/svg-icons/image/image"));
var _collections = _interopRequireDefault(require("material-ui/svg-icons/image/collections"));
var _web = _interopRequireDefault(require("material-ui/svg-icons/av/web"));
var _webAsset = _interopRequireDefault(require("material-ui/svg-icons/av/web-asset"));
var _palette = _interopRequireDefault(require("material-ui/svg-icons/image/palette"));
var _settings = _interopRequireDefault(require("material-ui/svg-icons/action/settings"));
var _launch = _interopRequireDefault(require("material-ui/svg-icons/action/launch"));
var _helpOutline = _interopRequireDefault(require("material-ui/svg-icons/action/help-outline"));
var _help = _interopRequireDefault(require("material-ui/svg-icons/action/help"));
var _gavel = _interopRequireDefault(require("material-ui/svg-icons/action/gavel"));
var _insertChart = _interopRequireDefault(require("material-ui/svg-icons/editor/insert-chart"));
var _accountCircle = _interopRequireDefault(require("material-ui/svg-icons/action/account-circle"));
var _exitToApp = _interopRequireDefault(require("material-ui/svg-icons/action/exit-to-app"));
var _folder = _interopRequireDefault(require("material-ui/svg-icons/file/folder"));
var _favorite = _interopRequireDefault(require("material-ui/svg-icons/action/favorite"));
var _comment = _interopRequireDefault(require("material-ui/svg-icons/communication/comment"));
var _modeComment = _interopRequireDefault(require("material-ui/svg-icons/editor/mode-comment"));
var _arrowBack = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-back"));
var _arrowForward = _interopRequireDefault(require("material-ui/svg-icons/navigation/arrow-forward"));
var _close = _interopRequireDefault(require("material-ui/svg-icons/navigation/close"));
var _chevronLeft = _interopRequireDefault(require("material-ui/svg-icons/navigation/chevron-left"));
var _chevronRight = _interopRequireDefault(require("material-ui/svg-icons/navigation/chevron-right"));
var _home = _interopRequireDefault(require("material-ui/svg-icons/action/home"));
var _locationOn = _interopRequireDefault(require("material-ui/svg-icons/communication/location-on"));
var _map = _interopRequireDefault(require("material-ui/svg-icons/maps/map"));
var _systemUpdateAlt = _interopRequireDefault(require("material-ui/svg-icons/action/system-update-alt"));
var _equalizer = _interopRequireDefault(require("material-ui/svg-icons/av/equalizer"));
var _event = _interopRequireDefault(require("material-ui/svg-icons/action/event"));
var _viewList = _interopRequireDefault(require("material-ui/svg-icons/action/view-list"));
var _feedback = _interopRequireDefault(require("material-ui/svg-icons/action/feedback"));
var _touchApp = _interopRequireDefault(require("material-ui/svg-icons/action/touch-app"));
var _devicesOther = _interopRequireDefault(require("material-ui/svg-icons/hardware/devices-other"));
var _supervisorAccount = _interopRequireDefault(require("material-ui/svg-icons/action/supervisor-account"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("./Icon.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
 * CUSTOM SVG ICONS ---------
 * SVG PATHS taken from the attached files
 */

var Category = function Category(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12 2l-5.5 9h11z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    cx: "17.5",
    cy: "17.5",
    r: "4.5"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M3 13.5h8v8H3z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  }));
};
var DesignIcon = function DesignIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M16.24 11.51l1.57-1.57-3.75-3.75-1.57 1.57-4.14-4.13c-.78-.78-2.05-.78-2.83 0l-1.9 1.9c-.78.78-.78 2.05 0 2.83l4.13 4.13L3 17.25V21h3.75l4.76-4.76 4.13 4.13c.95.95 2.23.6 2.83 0l1.9-1.9c.78-.78.78-2.05 0-2.83l-4.13-4.13zm-7.06-.44L5.04 6.94l1.89-1.9L8.2 6.31 7.02 7.5l1.41 1.41 1.19-1.19 1.45 1.45-1.89 1.9zm7.88 7.89l-4.13-4.13 1.9-1.9 1.45 1.45-1.19 1.19 1.41 1.41 1.19-1.19 1.27 1.27-1.9 1.9zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34c-.47-.47-1.12-.29-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
  }));
};
var RateDislikeIcon = function RateDislikeIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    id: "color",
    d: "M12,5c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S15.9,5,12,5z M16,14.6L14.6,16L12,13.4L9.4,16L8,14.6 l2.6-2.6L8.2,9.6l1.4-1.4l2.4,2.4L14.6,8L16,9.4L13.4,12L16,14.6z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "iconAndRing",
    fill: props.color2
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7 S15.9,19,12,19z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "14.6,8 12,10.6 9.6,8.2 8.2,9.6 10.6,12 8,14.6 9.4,16 12,13.4 14.6,16 16,14.6 13.4,12 16,9.4 \t"
  })));
};
var RateLikeIcon = function RateLikeIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    id: "color",
    d: "M12,5c-3.9,0-7,3.1-7,7s3.1,7,7,7s7-3.1,7-7S15.9,5,12,5z M11,16l-3-3l1.4-1.4l1.6,1.6l4.6-4.6 L17,10L11,16z"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "iconAndRing",
    fill: props.color2
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,19c-3.9,0-7-3.1-7-7s3.1-7,7-7s7,3.1,7,7 S15.9,19,12,19z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "11,13.2 9.4,11.6 8,13 11,16 17,10 15.6,8.6"
  })));
};
var RateNeutralIcon = function RateNeutralIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    id: "iconAndRing",
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M12,16c-2.2,0-4-1.8-4-4 s1.8-4,4-4s4,1.8,4,4S14.2,16,12,16z",
    fill: props.color2
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    id: "color",
    cx: "12",
    cy: "12",
    r: "4"
  }));
};
var RateStronglyDislikeIcon = function RateStronglyDislikeIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    id: "color",
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M17,15.6L15.6,17L12,13.4L8.4,17 L7,15.6l3.6-3.6L7,8.4L8.4,7l3.6,3.6L15.6,7L17,8.4L13.4,12L17,15.6z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "iconAndRing",
    points: "17,15.6 15.6,17 12,13.4 8.4,17 7,15.6 10.6,12 7,8.4 8.4,7 12,10.6 15.6,7 17,8.4 13.4,12 ",
    fill: props.color2
  }));
};
var RateStronglyLikeIcon = function RateStronglyLikeIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("path", {
    id: "color",
    d: "M12,2C6.5,2,2,6.5,2,12s4.5,10,10,10s10-4.5,10-10S17.5,2,12,2z M10,17l-5-5l1.4-1.4l3.6,3.6 l7.6-7.6L19,8L10,17z"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    id: "iconAndRing",
    points: "10,17 5,12 6.4,10.6 10,14.2 17.6,6.6 19,8 ",
    fill: props.color2
  }));
};
var NavChevronLeftIcon = function NavChevronLeftIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor,
    viewBox: "0 0 100 100"
  };
  //<polygon id="arrow" points="29,59.7 4.1,31.7 29,3.8 30.5,5.1 6.8,31.7 30.5,58.4 "/>
  //<path d="M33.985,7.861 L34.692,8.568 L19.261,24 L34.692,39.431 L33.985,40.138 L18.2,24.353 L17.847,24 L18.2,23.646 L33.985,7.861 z"/>

  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("g", {
    id: "nav-arrow-left"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M71.49,0 L73.589,2.19 L27.786,50.002 L73.589,97.81 L71.49,100 L24.637,51.095 L23.589,50.002 L24.637,48.905 L71.49,0 z"
  })));
};
var NavChevronRightIcon = function NavChevronRightIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor,
    viewBox: "0 0 100 100"
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("g", {
    id: "nav-arrow-right"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M25.688,0 L23.589,2.19 L69.392,50.002 L23.589,97.81 L25.688,100 L72.541,51.095 L73.589,50.002 L72.541,48.905 L25.688,0 z"
  })));
};
var PlayIcon = function PlayIcon(props) {
  var iconProps = {
    style: props.style,
    color: props.color,
    hoverColor: props.hoverColor,
    viewBox: "0 0 100 100"
  };
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], iconProps, /*#__PURE__*/_react["default"].createElement("g", {
    id: "play"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "ground",
    d: "M50,0.833 C22.958,0.833 0.833,22.958 0.833,50 C0.833,77.042 22.958,99.167 50,99.167 C77.042,99.167 99.167,77.042 99.167,50 C99.167,22.958 77.042,0.833 50,0.833 z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    id: "arrow",
    d: "M40.167,72.125 L40.167,27.875 L69.667,50 z"
  })));
};
var Icon = /*#__PURE__*/function (_React$Component) {
  _inherits(Icon, _React$Component);
  var _super = _createSuper(Icon);
  function Icon() {
    _classCallCheck(this, Icon);
    return _super.apply(this, arguments);
  }
  _createClass(Icon, [{
    key: "getIcon",
    value:
    // @todo Add a tooltip for collapsed icons with the label text
    function getIcon(icon, size, color, hoverColor, color2) {
      var iconProps = {
        style: {
          width: size,
          height: size
        },
        color: color,
        color2: color2,
        hoverColor: hoverColor
      };
      if (!color2) delete iconProps.color2;
      switch (icon) {
        case "account-circle":
          return /*#__PURE__*/_react["default"].createElement(_accountCircle["default"], iconProps);
        case "add-circle":
          return /*#__PURE__*/_react["default"].createElement(_addCircle["default"], iconProps);
        case "analytics":
          return /*#__PURE__*/_react["default"].createElement(_insertChart["default"], iconProps);
        case "arrow-back":
          return /*#__PURE__*/_react["default"].createElement(_arrowBack["default"], iconProps);
        case "arrow-forward":
          return /*#__PURE__*/_react["default"].createElement(_arrowForward["default"], iconProps);
        case "chevron-left":
          return /*#__PURE__*/_react["default"].createElement(_chevronLeft["default"], iconProps);
        case "chevron-right":
          return /*#__PURE__*/_react["default"].createElement(_chevronRight["default"], iconProps);
        case "close":
          return /*#__PURE__*/_react["default"].createElement(_close["default"], iconProps);
        case "collections":
          return /*#__PURE__*/_react["default"].createElement(_collections["default"], iconProps);
        case "comment":
          return /*#__PURE__*/_react["default"].createElement(_comment["default"], iconProps);
        case "design":
          return /*#__PURE__*/_react["default"].createElement(DesignIcon, iconProps);
        case "devices-other":
          return /*#__PURE__*/_react["default"].createElement(_devicesOther["default"], iconProps);
        case "cover":
        case "system-update-alt":
          return /*#__PURE__*/_react["default"].createElement(_systemUpdateAlt["default"], iconProps);
        case "event":
          return /*#__PURE__*/_react["default"].createElement(_event["default"], iconProps);
        case "exit-to-app":
          return /*#__PURE__*/_react["default"].createElement(_exitToApp["default"], iconProps);
        case "feedback":
          return /*#__PURE__*/_react["default"].createElement(_feedback["default"], iconProps);
        case "folder":
          return /*#__PURE__*/_react["default"].createElement(_folder["default"], iconProps);
        case "favorite":
          return /*#__PURE__*/_react["default"].createElement(_favorite["default"], iconProps);
        case "gavel":
          return /*#__PURE__*/_react["default"].createElement(_gavel["default"], iconProps);
        case "help":
          return /*#__PURE__*/_react["default"].createElement(_help["default"], iconProps);
        case "home":
          return /*#__PURE__*/_react["default"].createElement(_home["default"], iconProps);
        case "help-outline":
          return /*#__PURE__*/_react["default"].createElement(_helpOutline["default"], iconProps);
        case "image":
          return /*#__PURE__*/_react["default"].createElement(_image["default"], iconProps);
        case "launch":
          return /*#__PURE__*/_react["default"].createElement(_launch["default"], iconProps);
        case "location":
          return /*#__PURE__*/_react["default"].createElement(_locationOn["default"], iconProps);
        case "map":
          return /*#__PURE__*/_react["default"].createElement(_map["default"], iconProps);
        case "mode-comment":
          return /*#__PURE__*/_react["default"].createElement(_modeComment["default"], iconProps);
        case "nav-chevron-left":
          return /*#__PURE__*/_react["default"].createElement(NavChevronLeftIcon, iconProps);
        case "nav-chevron-right":
          return /*#__PURE__*/_react["default"].createElement(NavChevronRightIcon, iconProps);
        case "play":
          return /*#__PURE__*/_react["default"].createElement(PlayIcon, iconProps);
        case "palette":
          return /*#__PURE__*/_react["default"].createElement(_palette["default"], iconProps);
        case "rate-dislike":
          return /*#__PURE__*/_react["default"].createElement(RateDislikeIcon, iconProps);
        case "rate-like":
          return /*#__PURE__*/_react["default"].createElement(RateLikeIcon, iconProps);
        case "rate-neutral":
          return /*#__PURE__*/_react["default"].createElement(RateNeutralIcon, iconProps);
        case "rate-strongly-dislike":
          return /*#__PURE__*/_react["default"].createElement(RateStronglyDislikeIcon, iconProps);
        case "rate-strongly-like":
          return /*#__PURE__*/_react["default"].createElement(RateStronglyLikeIcon, iconProps);
        case "results":
        case "equalizer":
          return /*#__PURE__*/_react["default"].createElement(_equalizer["default"], iconProps);
        case "settings":
          return /*#__PURE__*/_react["default"].createElement(_settings["default"], iconProps);
        case "supervisor-account":
          return /*#__PURE__*/_react["default"].createElement(_supervisorAccount["default"], iconProps);
        case "category":
          return /*#__PURE__*/_react["default"].createElement(Category, iconProps);
        case "touch":
          return /*#__PURE__*/_react["default"].createElement(_touchApp["default"], iconProps);
        case "view-list":
          return /*#__PURE__*/_react["default"].createElement(_viewList["default"], iconProps);
        case "web":
          return /*#__PURE__*/_react["default"].createElement(_web["default"], iconProps);
        case "web-asset":
          return /*#__PURE__*/_react["default"].createElement(_webAsset["default"], iconProps);
        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(this.props.className ? this.props.className : "", " cms-icon"),
        style: this.props.style
      }, this.getIcon(this.props.icon, this.props.width, this.props.color, this.props.hoverColor, this.props.color2), this.props.label ? /*#__PURE__*/_react["default"].createElement("div", {
        className: "tooltip"
      }, this.props.label) : null);
    }
  }]);
  return Icon;
}(_react["default"].Component);
Icon.defaultProps = {
  width: 28,
  style: {},
  color: "rgba(0, 0, 0, 0.54)",
  label: "",
  hoverColor: undefined
};
Icon.propTypes = {
  icon: _propTypes["default"].string,
  width: _propTypes["default"].number,
  color: _propTypes["default"].string,
  color2: _propTypes["default"].string,
  hoverColor: _propTypes["default"].string,
  style: _propTypes["default"].object,
  label: _propTypes["default"].string
};
var _default = Icon;
exports["default"] = _default;